import React from 'react';

const Article = ({children}) => (
    <article className="page-content">{children}</article>
);

export default Article;